<template>
    <div class="map mapa-container" lat="lat" lng="lng">

        <ul v-if="icons.length != 0" class="nearby-tags">
            <li v-for="{ icon, tag } in icons" :key="icon" :class="{ ativo: selecionados.includes(tag) }">
                <label>
                    {{
                    /* @ts-ignore*/
                    i18n[tag]
                    }}

                    <input type="checkbox" v-show="false" :value="tag" v-model="selecionados" />
                </label>
            </li>
        </ul>

        <div ref="mapa" class="google-maps"></div>
    </div>
</template>
<script setup lang="ts">

import { search, type SearchResponse } from "../lib/proximity-search"
import L, { type Map } from 'leaflet'

import 'leaflet/dist/leaflet.css';
//import marker_icon_2x from 'leaflet/dist/images/marker-icon-2x.png';
import marker_icon from 'leaflet/dist/images/marker-icon.png';
import marker_shadow from 'leaflet/dist/images/marker-shadow.png';
import { computed, onMounted, ref, watch } from "vue";

let i18n = {
    "amenity:arts_centre": "Centro Artístico",
    "aeroway:aerodrome": "Aeroporto",
    "amenity:atm": "Caixa Eletrônico",
    "amenity:bank": "Banco",
    "amenity:bar": "Bar",
    "amenity:bus_station": "Estação de Ônibus",
    "amenity:cafe": 'Café',
    "amenity:car_wash": "Lavagem de Carro",
    "amenity:grave_yard": "Cemitério",
    "amenity:pharmacy": "Farmácia",
    "amenity:hospital": "Hospital",
    "amenity:library": "Biblioteca",
    "amenity:post_depot": "Depósito",
    "amenity:nightclub": "Clube Noturno",
    "amenity:parking": "Estacionamento",
    "amenity:police": "Polícia",
    "amenity:post_office": "Correios",
    "amenity:school": "Escola",
    "amenity:childcare": "Creche",
    "amenity:university": "Universidade",
    "amenity:restaurant": "Restaurante",
    "amenity:fuel": "Posto de Combustível",
    "craft:bakery": "Padaria",
    "shop:beauty": "Salão de Beleza",
    "shop:books": "Livraria",
    "shop:convenience": "Loja de Conveniência",
    "shop:chemist": "Farmácia",
    "shop:pet": "Pet Shop",
    "shop:mall": "Mercado",
    "shop:supermarket": "Supermercado",
    "landuse:cemetery": "Cemitério",
    "building:church": "Igreja",
    "building:stadium": "Estádio",
    "leisure:fitness_centre": "Academia",
    "leisure:sports_centre": "Centro Esportivo",
    "leisure:park": "Parque",
    "leisure:stadium": "Estádio",
    "tourism:museum": "Museu",
    "tourism:attraction": "Atração Turística",
    "public_transport:station": "Transporte Público"
};

interface Props {
    lat: number,
    lng: number,
    codigo: string
}

const props = defineProps<Props>()

const selecionados = ref<string[]>([])
const mapa = ref<HTMLDivElement>()

const pois = ref<SearchResponse>([])
let map: Map|null = null

const icons = computed(() => {





    let tags: string[] = pois.value.reduce((acc, row) => {
        return [...acc, ...row.tags]
    }, [] as string[]);

    tags = [...new Set(tags)].filter(tag => {
        if (!/^(amenity|shop|tourism|public_transportation|leisure|craft|building|aeroway|landuse)\:/.test(tag)) {
            return false;
        }

        if (!Object.keys(i18n).includes(tag)) {
            return false;
        }
        return true;
    });
    tags.sort();

    return tags.map(tag => ({
        tag,
        icon: `${document.baseURI}assets/images/map-icons/png/` + (tag.replace(':', '_')) + '.png'
    }));
})

const loadPois = async () => {


    let resp2 = await search({
        latitude: +props.lat,
        longitude: +props.lng
    }, {
        precision: 5
    })



    resp2 = resp2.map((poi: any) => {
        return {
            ...poi,
            id: +poi.id,
            tags: poi.tags.split(',')
        }
    })



    let ids2 = [...new Set(resp2.map(({ id: place_id }) => place_id))];


    let resp3 = ids2.map(id => resp2.find(poi => poi.id == id)).filter(row => row !== undefined);

    pois.value = resp3
}
loadPois()

const mountMaps = async () => {
    if (!mapa.value) {
        return
    }
    if (map !== null) {
        map.remove();
    }
    
    map = L.map(mapa.value).setView([+props.lat, +props.lng], 17);

    let icon2 = L.icon({

        iconUrl: `${marker_icon}`,
        shadowUrl: `${marker_shadow}`
    });
    L.tileLayer(`https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?t=${Date.now()}`, { attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>' })
        .addTo(map);

    let mainMarker = L.circle([+props.lat, +props.lng], {
        color: 'black',
        fillColor: '#000',
        fillOpacity: 0.5,
        radius: 500
    }).addTo(map);

    let markers = pois.value.filter(({ tags }) => {
        let retorno = tags.filter(tag => selecionados.value.includes(tag));
        return retorno.length > 0;
    });

    let markers2 = markers.map(place => {
        return L.marker([+place.lat, +place.lng], {
            icon: icon2,
            title: place.name
        });
    });

    let featureGroup = L.featureGroup([mainMarker, ...markers2]).addTo(map);

    map.fitBounds(featureGroup.getBounds());
}

onMounted(() => {
    mountMaps()
})

watch(pois, () => {
    mountMaps()
})

watch(selecionados, () => {
    mountMaps()
})

</script>

<style lang="less" scoped>
.mapa-container {
    .google-maps {
        width: 100%;
        height: 450px;
    }

    ul {
        li {
            margin-right: 0.2em;

            [type=checkbox] {
                display: none;
            }

            &.ativo {
                span {

                    background-color: black;
                    color: white;
                }
            }
        }
    }
}
</style>